import React, { useContext } from "react";
import {
  BoldLink,
  BoxContainer,
  FormContainer,
  Input,
  LineText,
  MutedLink,
  SubmitButton,
} from "./common";
import { Marginer } from "../marginer";
import { AccountContext } from './accountContext';
import { UserAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import {auth} from "../../firebase"
import { signInWithEmailAndPassword } from "firebase/auth";

export function LoginForm(props) {

  const { switchToSignup } = useContext(AccountContext);
  const {emailSignIn}= UserAuth();
  const navigate = useNavigate();

  return (
    <BoxContainer>
      <FormContainer onSubmit={async (e)=>{
        e.preventDefault()
        console.log(e.target.email.value)
        console.log(e.target.password.value)

      const res =  await signInWithEmailAndPassword(auth, e.target.email.value, e.target.password.value)
      console.log(res)
      if(res.user){
        navigate("/")}
      else{
        alert("Please check your email and password")
      }


      }}>
        <Input type="email" placeholder="Email" name="email" />
        <Input type="password" placeholder="Password" name="password" />
        <Marginer direction="vertical" margin="1.6em" />
        <center><SubmitButton type="submit">Signin</SubmitButton> </center>
      </FormContainer>
      <Marginer direction="vertical" margin={10} />
      {/* <MutedLink href="#">Forget your password?</MutedLink> */}
   
      <Marginer direction="vertical" margin="5px" />
      <LineText>
        Don't have an accoun?{" "}
        <BoldLink onClick={switchToSignup} href="#">
          Signup
        </BoldLink>
      </LineText>
    </BoxContainer>
  );
}